import React from 'react';
import NaptarBejegyzesekContent from './NaptarBejegyzesekContent';
import { cegesAutoService } from '../services/cegesAutoService';
import { Permissions } from '../services/permissionService';

const CegesAutoContent: React.FC = () => {
  return (
    <NaptarBejegyzesekContent
      title="Céges autó"
      selectedMenu="cegesauto"
      service={cegesAutoService}
      createPermission={Permissions.CreateCompanyCar}
      editPermission={Permissions.EditCompanyCar}
      deletePermission={Permissions.DeleteCompanyCar}
      addDialogTitle="Új céges autó foglalás"
    />
  );
};

export default CegesAutoContent;
